import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../constants'

export const Tab = ({ activeTab, setActiveTab }) => {
  return (
    <Root>
      <NavTab
        active={ activeTab === 0 }
        onClick={ () => setActiveTab(0) }
      >
        Project Information
      </NavTab>
      <NavTab
        active={ activeTab === 1 }
        onClick={ () => setActiveTab(1) }
      >
        Cost planning
      </NavTab>
    </Root>
  )
}

const Root = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
`

const NavTab = styled.div`
  height: 40px;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin: 0 16px;
  color: ${p => (p.active ? '#AD2624' : '#808080')};
  border-bottom: ${p => (p.active ? '4px solid #AD2624' : 'none')};

  ${p => (p.active && `
    margin-bottom: -4px;
  `)}
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/tab.js